import { Deserializable } from '../../lib/models/deserializable';
import { ProductSpecialFeatureDto } from './product-special-feature-dto.model';

export class ProductDto implements Deserializable {
  public ProductID: number;
  public TermOther: string;
  public TypApr?: number;
  public MaxLtv?: number;
  public ArrangementFee?: number;
  public ArrangementFeeAsPercentage: boolean;
  public EarlyRedemptionCharge: string;
  public MonthlyRepayments?: number;
  public ProductCode: string;
  public ProductName: string;
  public Rate?: number;
  public Description: string;
  public IsExpired: boolean;
  public PromotionalRatePeriodCost: number;
  public PromotionalRateEndDate?: Date;
  public ComparativeTotal: number;
  public BalanceRemaining: number;
  public ProductSpecialFeatures: Array<ProductSpecialFeatureDto>;
  public IsAvailable: boolean;
  public IsTermChangeAvailable: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);
    if (input.ProductSpecialFeatures) {
      this.ProductSpecialFeatures = input.ProductSpecialFeatures.map(
        (productSpecialFeatureDto: ProductSpecialFeatureDto) =>
          new ProductSpecialFeatureDto().deserialize(productSpecialFeatureDto)
      );
    }

    return this;
  }
}
